function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTruckSolidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 112.73 110.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "32.91 99.92 32.91 99.92 32.9 99.91 32.91 99.92",
    style: {
      fill: "#1eb0d2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.31 84.55 4.3 84.55 4.3 84.55 4.31 84.55 4.31 84.55",
    style: {
      fill: "#1eb0d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.38,88.09C.3,88,.22,88,.14,87.88.22,88,.3,88,.38,88.09Z",
    style: {
      fill: "#009cc1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.31 84.55 4.3 84.55 4.3 84.56 4.31 84.55",
    style: {
      fill: "#009cc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.94,24,77.34,43.79a4.53,4.53,0,0,0-2.19,3.88V78.83a2,2,0,0,0,3,1.72l4.33-2.8c.06-7.9,5.6-17.44,12.45-21.4,6.63-3.83,12.06-1,12.49,6.26l3-1.74a5.09,5.09,0,0,0,2.35-4.29l0-31A1.84,1.84,0,0,0,109.94,24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.67,105.85l-2.19-1.27h0L0,85.24v2.58a14.94,14.94,0,0,0,.13,1.91,2.39,2.39,0,0,0,.2.43,2.14,2.14,0,0,0,.28.39l.1.11a1.64,1.64,0,0,0,.25.21,1.27,1.27,0,0,0,.27.18l33.62,19.44a2.47,2.47,0,0,0,2.67.17c1-.56,3.73-2.16,3.73-2.16s.84-.62.84-1.35v-4l-4,2.63A2.37,2.37,0,0,1,35.67,105.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.59,44.58,42.9,32.06a4.65,4.65,0,0,0-4.65,0L18.77,43.37a6,6,0,0,0-2.58,3C14.3,51.2,9.58,63.26,9.54,63.29L5.35,66.85A2.87,2.87,0,0,0,4.47,69v10.9a2.55,2.55,0,0,0,1.27,2.23l10.72,6.2v-9.1a1.3,1.3,0,0,1,1.94-1.13L25,82a4,4,0,0,1,2,3.48v9l9.12,5.29a2.85,2.85,0,0,0,2.88,0l1.43-.82C41.54,92.21,46.19,85,51.78,81.74s10.29-1.37,11.4,4.06l3.87-2.23V48.84A4.92,4.92,0,0,0,64.59,44.58ZM10.35,81.48a7.67,7.67,0,0,1-3.48-6c0-2.22,1.58-3.11,3.5-2a7.65,7.65,0,0,1,3.48,6C13.85,81.7,12.28,82.59,10.35,81.48ZM33.21,94.71a7.67,7.67,0,0,1-3.48-6c0-2.22,1.57-3.11,3.5-2a7.65,7.65,0,0,1,3.48,6C36.7,94.93,35.13,95.82,33.21,94.71Zm9.56-31.87-4.3,11.87a1.7,1.7,0,0,1-2.45.9L15,63.76a1.7,1.7,0,0,1-.74-2.07l4.39-11.84A1.7,1.7,0,0,1,21.12,49L42,60.79A1.69,1.69,0,0,1,42.77,62.84Zm18.32,4-15.37,9.2a1.1,1.1,0,0,1-1.64-1.15l3.65-10.52a9.57,9.57,0,0,1,3.33-4.77l8.75-5.29a1.28,1.28,0,0,1,2.09,1.09v10A1.7,1.7,0,0,1,61.09,66.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5,88.82a15,15,0,0,0-6.82,11.81c0,4.34,3.09,6.09,6.87,3.91a15.06,15.06,0,0,0,6.82-11.81C59.35,88.39,56.28,86.64,52.5,88.82Zm0,10.79c-1.41.82-2.55.16-2.56-1.46a5.61,5.61,0,0,1,2.55-4.4c1.41-.82,2.55-.16,2.56,1.46A5.62,5.62,0,0,1,52.53,99.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4,63.24a15,15,0,0,0-6.82,11.81c0,4.34,3.08,6.09,6.86,3.91a15,15,0,0,0,6.82-11.81C102.25,62.81,99.18,61.06,95.4,63.24Zm0,11.06c-1.54.89-2.79.17-2.79-1.59a6.09,6.09,0,0,1,2.77-4.8C97,67,98.2,67.73,98.2,69.5A6.09,6.09,0,0,1,95.43,74.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.06,38.21a6.71,6.71,0,0,1-3.36-.9L46.14,24.66a3.71,3.71,0,0,1,0-6.42l29-17a9.41,9.41,0,0,1,9.41,0l21,12.24a2.82,2.82,0,0,1,0,4.86L74.51,37.25a6.67,6.67,0,0,1-3.45,1Z",
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckSolidIcon);
export default __webpack_public_path__ + "static/media/truck_solid_icon.47e2b55a5dfdb5494d53c1ce761d86f6.svg";
export { ForwardRef as ReactComponent };